<script lang="ts" setup>
import { useSearchStore } from '@autobid/nuxt-pinia-store/store/searchStore/useSearchStore'
import ChipsButton from '@autobid/ui/components/common/Chips/ChipsButton.vue'
import ChipsWrapper from '@autobid/ui/components/common/Chips/ChipsWrapper.vue'
import { storeToRefs } from 'pinia'
import SearchFormChipsContent from './SearchFormChipsContent.vue'

const { reset } = useSearchStore()

const { chips } = storeToRefs(useSearchStore())
</script>

<template>
  <div v-if="chips.length">
    <Teleport to="#global-teleport-target">
      <ChipsWrapper :="$attrs">
        <SearchFormChipsContent :chips="chips" />
        <ChipsButton class="bg-red" @click="reset">
          {{ $t('search-form.reset-filters') }}
        </ChipsButton>
      </ChipsWrapper>
    </Teleport>
  </div>
</template>
